/* eslint-disable import/prefer-default-export */
import { RSAA } from 'redux-api-middleware'

import { EstateUtils, UrlUtils } from '../utils'

export const StatisticsActions = {
    STATISTICS_FETCH_STORE_REQUEST: 'STATISTICS_FETCH_STORE##REQUEST',
    STATISTICS_FETCH_STORE_SUCCESS: 'STATISTICS_FETCH_STORE##SUCCESS',
    STATISTICS_FETCH_STORE_FAILURE: 'STATISTICS_FETCH_STORE##FAILURE',
    STATISTICS_FETCH_REQUEST: 'STATISTICS_FETCH##REQUEST',
    STATISTICS_FETCH_SUCCESS: 'STATISTICS_FETCH##SUCCESS',
    API_CALL_FAILURE: 'API_CALL##FAILURE',
}

/**
 * Fetch store information
 * @param {String} storeCode
 */
const fetchStoreForStatistics = (storeCode) => {
    return (dispatch, getState) => {
        const state = getState()
        const api = EstateUtils.getAPI(state)
        return dispatch({
            [RSAA]: {
                endpoint: `${api}/stores/${storeCode}`,
                method: 'GET',
                types: [
                    StatisticsActions.STATISTICS_FETCH_STORE_REQUEST,
                    StatisticsActions.STATISTICS_FETCH_STORE_SUCCESS,
                    StatisticsActions.STATISTICS_FETCH_STORE_FAILURE,
                ],
            },
        })
    }
}

/**
 * Fetches statistics and related information
 * @param {Object} params
 * @param {String} params.storeCode
 * @param {Number} params.hours
 */
export const fetchStatistics =
    ({ storeCode, hours } = {}) =>
    async (dispatch, getState) => {
        // Check parameters for url query
        const params = {}

        if (storeCode > 0) {
            params.storecode = storeCode
        }

        if (hours) {
            params.hours = hours
        }

        const query = UrlUtils.buildQueryString(params)

        // Fetch statistics
        await dispatch({
            [RSAA]: {
                endpoint: `${EstateUtils.getAPI(getState())}/statistics?${query}`,
                method: 'GET',
                types: [StatisticsActions.STATISTICS_FETCH_REQUEST, StatisticsActions.STATISTICS_FETCH_SUCCESS, StatisticsActions.API_CALL_FAILURE],
            },
        })

        // Fetch stores information
        const state = getState()
        const {
            statistics: {
                data: { bottomStores, topStores },
            },
        } = state

        // Filter all the stores to fetch. For every store, just keep them once, removing repeated
        const filteringMap = {}
        const filteredStores = [...bottomStores, ...topStores].filter(({ store_code: code }) => {
            if (filteringMap[code]) {
                return false
            }

            filteringMap[code] = true
            return true
        })

        return Promise.all(filteredStores.map(({ store_code: code }) => dispatch(fetchStoreForStatistics(code))))
    }
